<div class="resetpassword pt-5">
  <div class="card mx-auto" style="width:60%">
    <div class="card-body">
      <div>
        <mat-toolbar class="agGridtoperDiv card">
          <span class="example-spacer"></span>
          <span i18n="@@spmsshiftmaster">Reset Password</span>
          <span class="example-spacer"></span>
        </mat-toolbar>
      </div>
      
      <div class="card mb-3" style="width:100%;color:black">
        <div class="card-body" style="width:100%;">
          <h5 class="card-title" style="font-size: 19px;text-align: center">
            Your Password has been changed Successfully
          </h5>
          
          <!-- Button moved INSIDE card-body -->
          <div class="button-container" style="margin-top: 20px;">
            <button
              i18n="@@targetforgotpasswordnothanks"
              type="button"
              class="btn btn-center-blue"
              routerLink="/session/login"
            >
              Login Page
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>